import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { NgClass } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: 'app-confirm-dialog',
  styles: ['.buttons-wrap { text-wrap: auto; }'],
  standalone: true,
  imports: [
    NgClass,
    MatButtonModule
  ],
  template: `
    <div class="container px-0" style="height: fit-content;">
      <h4>{{ title }}</h4>
      <hr class='border-primary'>
      <p [hidden]="!!customHtml" [innerHTML]="message" style="word-wrap: break-word"></p>
      <iframe #customTariffName [hidden]="!customHtml" class="my-1" [srcdoc]="customHtml"
              style="max-height: 70vh; overflow-y: auto; width: 100%;" frameborder="0"
              title="Custom HTML frame"></iframe>
      <div class="d-flex align-items-center justify-content-center flex-wrap"
           [ngClass]="{ 'flex-row-reverse': reverseButtonDirection, 'flex-row': !reverseButtonDirection }">
        <button type="button" mat-raised-button *ngIf="true"
                (click)="dialogRef.close(true)" class="btn is-link pad-bottom-8px buttons-wrap"
                [ngClass]="{'is-danger': !buttonColorRevert}">{{ confirmBtnTxt }}
        </button>
        <button type="button" mat-button *ngIf="!hideCancelButton && !cancelReturnsFalse"
                (click)="dialogRef.close()" class="btn is-link pad-bottom-8px buttons-wrap"
                [ngClass]="{'is-danger': buttonColorRevert}">{{ cancelBtnTxt }}
        </button>
        <button type="button" mat-button *ngIf="!hideCancelButton && cancelReturnsFalse"
                (click)="dialogRef.close(false)" class="btn is-link pad-bottom-8px buttons-wrap"
                [ngClass]="{'is-danger': buttonColorRevert}">{{ cancelBtnTxt }}
        </button>
      </div>
      <p [innerHTML]="footer" class="mb-0" style="word-wrap: break-word; margin-top: var(1rem - 4px);"></p>
    </div>
  `
})

export class ConfirmDialogComponent implements AfterViewInit {
    public title: string = "";
    public message: string = "";
    public customHtml: string = "";
    public footer : string | null = null;
    public confirmBtnTxt = 'Confirm';
    public cancelBtnTxt = 'Cancel';
    public buttonColorRevert = false;
    public hideCancelButton = false;
    // If this is false, clicking the overlay and cancel buttons both return undefined (original behaviour)
    // If true, clicking cancel returns false and clicking the overlay returns undefined
    // (Allows for distinguishing these actions)
    public cancelReturnsFalse = false;
    public reverseButtonDirection = false;

    @ViewChild("customTariffName")
    private customTariffName!: ElementRef<HTMLIFrameElement>;

    constructor(public dialogRef : MatDialogRef <ConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data && data.hideCancelButton) {
            this.hideCancelButton = data.hideCancelButton;
        }

        if (data && data.isMobile) {
            this.dialogRef.addPanelClass("mat-dialog-container-mobile");
        }
    }

    ngAfterViewInit(): void {
        // Set iframe's size based on its content to avoid a scroll bar
        this.customTariffName.nativeElement.onload = () => {
            this.customTariffName.nativeElement.height = ((this.customTariffName.nativeElement.contentDocument?.body.scrollHeight ?? 0) + 40) + "px";
        };
    }
}
